import React from 'react';
import {ContextMenuServiceProvider} from '../ContextMenuService';

/**
 * wrap component in context menu
 * @example
	const WrappedComponenet = withContextMenu(Componenet);
 */
export const withContextMenu = function <C extends React.ElementType>(
	Component: C,
) {
	return (
		props: JSX.IntrinsicAttributes &
			JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>,
	) => {
		return (
			<ContextMenuServiceProvider>
				<Component {...props} />
			</ContextMenuServiceProvider>
		);
	};
};

export default withContextMenu;
